import { Button, FormControlLabel, Grid, makeStyles, styled, Switch, Typography } from "@material-ui/core"
import SimpleModal from "../../../../../../components/Modals/SimpleModal"
import system_translations from "../../../../../../texts/system_translations"
import useAddBannerModal from "./useAddBannerModal"
import ImagesMenu from "../../../../../../components/Structure/Nav/ImagesMenu"
import InputForm from "../../../../../../components/Forms/InputForm"
import LoadingButton from "../../../../../../components/Actions/LoadingButton"
import { ColorPicker } from 'material-ui-color';
import ImageContainer from "../../../../../../components/Ecommerce/ImageContainer"
import ChangeImageModal from "./ChangeImageModal"


const AddBannerModal = ({ open, onClose, language, onCompletedBanners }) => {

    const classes = useStyles()
    const content = system_translations[language].modals.banner
    const { system, form, actions,img_view, view_data_desktop, view_data_mobile, upload_image } = useAddBannerModal({ open, language, content, onCompletedBanners })

    const view_data = img_view === 1 ? view_data_desktop : view_data_mobile


    let contentView = <ImageContainer ratio='16/9' variant='cover' src_crop={view_data.crop_image ? view_data.crop_image : null} onUpload={() => actions.onChangeModal(true)} />

    return (
        <SimpleModal open={open} onClose={onClose} maxWidth='sm' >
            <ChangeImageModal open={upload_image} onClose={() => actions.onChangeModal(false)} language={language}
                type={img_view === 1 ? 'web' : 'mobile'} onUpdateDataImage={actions.onUpdateDataImage} />
            <div className={classes.titleContainer}><Typography className={classes.title}>{content.add.title}</Typography></div>
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container justifyContent='space-between' alignItems='center'>
                            <Grid item>
                                <ImagesMenu menu={content.imgs_menu} selected={img_view} onChange={(id) => actions.onChangeImgView(id)} />
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={<CostumSwitch checked={view_data.enable} onChange={actions.onChangeEnable} />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        {contentView}
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justifyContent='space-between'>
                            <Grid item>
                                <div className={classes.color_container}>
                                    <Typography className={classes.text_color} variant='body2' >{content.text_color}</Typography>
                                    <div className={classes.color_picker}>
                                        <ColorPicker value={view_data.text_color} hideTextfield disableAlpha onChange={actions.onChangeTextColor} />
                                    </div>
                                </div>
                            </Grid>
                            <Grid item style={{marginBottom: 15}}>
                                <div className={classes.color_container}>
                                    <Typography className={classes.text_color} variant='body2'>{content.back_color}</Typography>
                                    <div className={classes.color_picker}>
                                        <ColorPicker value={view_data.back_color} hideTextfield disableAlpha onChange={actions.onChangeBackColor} />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <InputForm data={form.date} onChange={actions.onChangeForm} />
                    </Grid>
                    <Grid item xs={12}>
                        <InputForm data={form.title} onChange={actions.onChangeForm} />
                    </Grid>
                    <Grid item xs={12}>
                        <InputForm data={form.subtitle} onChange={actions.onChangeForm} />
                    </Grid>
                    <Grid item xs={12}>
                        <InputForm data={form.description} onChange={actions.onChangeForm} />
                    </Grid>
                    <Grid item xs={6}>
                        <InputForm data={form.web_link} onChange={actions.onChangeForm} />
                    </Grid>
                    <Grid item xs={6}>
                        <InputForm data={form.app_link} onChange={actions.onChangeForm} />
                    </Grid>
                </Grid>
            </div>
            <div className={classes.bottom_section}>
                <LoadingButton loading={system.sending} onClick={actions.onSubmit}>{content.add.button}</LoadingButton>
            </div>
        </SimpleModal>
    )

}

export default AddBannerModal

const useStyles = makeStyles(theme => ({
    titleContainer: {
        marginBottom: 40
    },
    title: {
        fontSize: 20,
        fontWeight: 700
    },
    bottom_section: {
        textAlign: 'center',
        margin: '80px 0px 12px'
    },
    color_circle: {
        borderRadius: '50%',
        border: '2px solid #CBCBCB',
        boxSizing: 'border-box',
        width: 20,
        height: 20,
        marginLeft: 8,
        marginTop: 2
    },
    color_container: {
        display: 'flex'
    },
    color_picker: {

    },
    text_color: {
        marginTop: 6
    }

}))

const CostumSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                //backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                backgroundColor: theme.palette.primary.dark,
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#C9C9C9',
        //backgroundColor: theme.palette.primary.dark,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));